import { colors } from '@mehilainen/mds-tokens';
export const getThemeLink = (tokens) => ({
    MuiLink: {
        styleOverrides: {
            root: {
                textDecorationColor: 'inherit',
                ['& > svg']: {
                    verticalAlign: 'text-bottom',
                },
                variants: [
                    {
                        props: { color: 'primary' },
                        style: {
                            color: colors.Primary[500],
                            '&:hover': {
                                color: tokens.uiElementLink.hoverColor.primary,
                            },
                        },
                    },
                    {
                        props: { color: 'error' },
                        style: {
                            color: colors.Error[500],
                            '&:hover': {
                                color: tokens.uiElementLink.hoverColor.error,
                            },
                        },
                    },
                ],
            },
        },
    },
});
